import HttpService from '@/api/HttpService';

import {
  SET_USER_STATUS,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    userStatus: null,
  },
  mutations: {
    [SET_USER_STATUS](state, userStatus) {
      state.userStatus = userStatus;
    },
  },
  actions: {
    getUserStatus({ commit }, { accountId }) {
      commit(SET_USER_STATUS, null);

      return HttpService.getV2(`users/user/accounts/${accountId}/status`)
        .then((status) => {
          commit(SET_USER_STATUS, status);
          return status;
        });
    },
    setOnBoardingComplete() {
      return HttpService.postV2('/users/onboarding/complete');
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/home.js